import { render } from "./PasswordChanged.vue?vue&type=template&id=1cfd9d7a&scoped=true"
import script from "./PasswordChanged.vue?vue&type=script&lang=js"
export * from "./PasswordChanged.vue?vue&type=script&lang=js"

import "./PasswordChanged.vue?vue&type=style&index=0&id=1cfd9d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfd9d7a"]])

export default __exports__